function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext } from 'react';
import ReactDOM from 'react-dom/client';
import { history } from '../history';
const globalContext = {};
export const setGlobalContext = (key, value)=>{
    globalContext[key] = value;
};
export const GlobalContext = /*#__PURE__*/ createContext(globalContext);
export const useGlobalContext = ()=>useContext(GlobalContext);
export const GlobalContextProvider = ({ children })=>/*#__PURE__*/ _jsx(GlobalContext.Provider, {
        value: globalContext,
        children: children
    });
const defaultOptions = {
    container: 'body',
    unmountOnNavigation: false
};
export default function utilify(renderComponent) {
    return (props)=>{
        const mountHolderElement = document.createElement('div');
        let mountHolderRoot;
        let isAppended = false;
        let unListener;
        function unMountComponent() {
            if (!isAppended) return;
            //* pre assign false - because unmount() internally can call render()
            //* and skips the assignment for isAppended (which throws an error)
            //* and tries to render unmounted component.
            isAppended = false;
            mountHolderRoot === null || mountHolderRoot === void 0 ? void 0 : mountHolderRoot.unmount();
            mountHolderElement.remove();
            unListener === null || unListener === void 0 ? void 0 : unListener();
        }
        function render(element, options = defaultOptions) {
            const { container, unmountOnNavigation } = _object_spread({}, defaultOptions, options);
            const $container = document.querySelector(container);
            if (!isAppended) {
                isAppended = true;
                $container === null || $container === void 0 ? void 0 : $container.appendChild(mountHolderElement);
                mountHolderRoot = ReactDOM.createRoot(mountHolderElement);
                // if unmountOnNavigation is set, attach a listener on history object to observe location
                if (unmountOnNavigation) {
                    const { pathname } = document.location;
                    unListener = history.listen(({ location })=>{
                        if (pathname !== location.pathname) {
                            unMountComponent();
                        }
                    });
                }
            }
            mountHolderRoot.render(/*#__PURE__*/ _jsx(GlobalContextProvider, {
                children: element
            }));
        }
        // render component can return promises or anything the component wants to return
        return renderComponent({
            props,
            render,
            unmount: unMountComponent
        });
    };
}
